import ReplyArea from './ReplyArea';

export default ReplyArea;